import {
  getInventoryIdsFromSearchResponse,
  getPricesForSearchResult,
  getDataForInventories,
} from "@retailer/services/pricing_data_service";
import { updateProductLineListingStore } from "@retailer/svelte/ProductLines/ProductLineContainer/stores/ProductLineListingStore";
import { setInventoryStatusesInStore } from "@retailer/services/inventory_statuses_service";
import InventoryStatusStore from "@shared/svelte/Stores/InventoryStatusStore";
import type { PricingDataResult } from "@shared/types/Pricing";

const setPricesInStore = (inventoryPrices = []) => {
  updateProductLineListingStore(n => {
    n.loadingPrices = false;
    n.inventoryPrices = inventoryPrices;
    return n;
  });
};

const extractVerifiedInStockFromProductLines = productLines => {
  const result = {};
  productLines.map(productLine => {
    const productLineInventoryData =
      productLine.products
        ?.map(product => {
          return product.inventory.map(inventory => {
            return {
              product_id: product.id,
              inventory_id: inventory.id,
              verified_in_stock: inventory.verified_in_stock,
            };
          });
        })
        ?.flat() || [];
    result[productLine.id] = productLineInventoryData;
  });

  return result;
};

export const fetchDiscountData = async productLines => {
  if (!productLines?.length) {
    return;
  }

  const inventoryIds = getInventoryIdsFromSearchResponse(productLines);
  if (inventoryIds.length === 0) return;

  // This should preload for the PLP
  const results: PricingDataResult[] = await getDataForInventories(inventoryIds);
  // Search Service doesn't have Happy Hour data yet,
  // so we need to override with this data to display the deal tag
  // and to apply the deal filter correctly
  productLines.forEach(productLine => {
    let products = productLine.products || [];
    let inventories = products.map(product => product.inventory).flat();
    let hasDiscount = inventories.some(inventory => {
      // Type coerce because inventory.id can be a string
      let pricingData = results.find(result => {
        return result.inventory_id == inventory.id;
      });
      return pricingData && pricingData.discounts?.length > 0;
    });
    //overrides search service data to make happy hour source of truth
    const hasFuturePrice = inventories.some(inventory => {
      const pricingData = results.find(result => {
        return result.inventory_id == inventory.id;
      });

      return pricingData?.future_price?.future_prices?.length > 0;
    });

    productLine.future_prices_available = hasFuturePrice;

    productLine.distributor_info.has_discount = hasDiscount;
  });
};

export const fetchSupplementalData = productLines => {
  if (!productLines?.length) {
    return;
  }
  updateProductLineListingStore(n => {
    n.loadingPrices = true;
    n.inventoryPrices = [];
    return n;
  });

  InventoryStatusStore.update(n => {
    n.loadingInventoryStatuses = true;
    n.inventoryStatuses = {};
    n.numberOfSkusInStock = {};
    return n;
  });

  getPricesForSearchResult(productLines)
    .then(prices => {
      setPricesInStore(prices);
    })
    .catch(() => {
      setPricesInStore([]);
    });

  const verifiedInStockData = extractVerifiedInStockFromProductLines(productLines);
  setInventoryStatusesInStore(verifiedInStockData);
};
